import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { OptionsSelector } from '@nibtravel/shared/data-access/options';
import { QuoteActions } from '@nibtravel/shared/data-access/quote';
import {
  emptyBasicOption,
  IBasicOptionInput,
  IBasicOptionSummary,
  OptionType,
  QuoteStage,
} from '@nibtravel/shared/util/models';
import { Observable } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';

import { PmiOption } from './pmi-option.state.facade';
import { Qqc } from '@nibtravel/shared/util/e2e';

@Component({
  selector: 'nibtravel-pmi-option',
  templateUrl: './pmi-option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PmiOption],
})
export class PmiOptionComponent {
  @Input() isQqc = false;

  leadText = `To enjoy a lower travel premium, Private Medical Insurance must
  be active for all insured persons for the full duration of their travel abroad.
  Without proof of active PMI cover for all at time of claim, we may decline a
  medical expenses claim or reduce settlement. You can insure travellers with
  and without PMI cover under separate travel policies.`;

  e2eId = Qqc;

  @Select(PmiOption.isOptedIn)
  checked$!: Observable<boolean>;

  @Select(PmiOption.pmiOption)
  pmiOption$!: Observable<IBasicOptionSummary | undefined>;

  @Select(OptionsSelector.currencyCode)
  currencyCode$!: Observable<string>;

  constructor(private store: Store) {}

  onValueChange(value: boolean): void {
    const pmiOption: IBasicOptionInput = {
      ...emptyBasicOption,
      optionType: OptionType.PrivateMedicalInsurance,
      isOptedIn: value,
    };

    this.dispatch(new QuoteActions.SetBasicOptions(pmiOption)).subscribe(() => {
      if (!this.isQqc) {
        this.dispatch(this.stage(QuoteStage.Options))
          .pipe(
            switchMap(() => this.dispatch(new QuoteActions.GetQuote())),
            finalize(() => this.dispatch(this.stage(QuoteStage.Details)))
          )
          .subscribe();
      }
    });
  }

  private dispatch(event: any | any[]): Observable<any> {
    return this.store.dispatch(event);
  }

  private stage(stage: QuoteStage) {
    return new QuoteActions.SetQuoteStage(stage);
  }
}
